export default {
  login: {
    title: 'Login',
    error: {
      invalidEmail: 'Invalid email',
      invalidPassword: 'Invalid password',
      badCredentialsTitle: 'Incorrect credentials',
      accountLockedTitle: 'Account access has been locked',
      accountLockedCaption: 'You can contact us at {contactEmail}',
      badCredentialsCaption: 'Please check your email and password.',
      tooManyAttemptsRetryAfter: 'Too many attempts. Please try again in {durationRemaining}.',
      tooManyAttempts: 'Too many attempts. Please try again later',
      unavailableIdentityProvider: 'Login with this authentication method is currently unavailable. Please try again later.'
    }
  },
  passwordRenewal: {
    title: 'Password Renewal',
    newPassword: 'You can now enter your new login password',
    success: {
      title: 'Password renewal successful',
      message: 'The password associated with your account has been successfully changed. You can now log in with your new password.',
      redirect: 'You will be redirected to the requested page in a few seconds.',
      redirectButton: 'Immediate redirection'
    },
    error: 'The new password must be different from the old one'
  },
  forgotPassword: {
    title: 'Password Reset',
    subTitle: {
      email: 'Please provide your email address. You will receive a code in your inbox to reset your password.',
      sms: 'Please provide your phone number. You will receive a code by SMS to reset your password'
    },
    useAnotherMethod: 'Use another method',
    chooseEmail: 'Receive a code via email',
    chooseSms: 'Receive a code via sms',
    newPassword: 'You can now enter your new login password',
    codeSent: {
      email: 'An email with your code has been sent. Please enter it in the fields below',
      sms: 'An sms with your code has been sent. Please enter it in the fields below'
    },
    waitBeforeRetry: 'Please wait {timeRemaining} seconds before retrying',
    tooManyTrials: 'You have exceeded the limit of attempts for this code. Please restart the operation',
    success: {
      title: 'Password change successful',
      message: 'The password associated with your account has been successfully changed. You can now log in with your new password.',
      redirect: 'You will be redirected to the login form in a few seconds.'
    }
  },
  pendingStatus: {
    title: 'Account Pending Validation',
    subTitle: 'Your identity must be verified before you can log in.'
  },
  cgu: {
    label: 'Terms of Service',
    checkbox: 'I have read and accept the'
  },
  mfa: {
    title: 'Two-step verification',
    helper: 'For security reasons, two-step verification is required to access your account. Please select a verification method',
    chooseMail: 'Receive a verification code at your email address',
    choosePhone: 'Receive a verification code via SMS at',
    smsSent: 'A SMS containing your code has been sent to {userSms}. Please enter it in the fields below',
    checkCode: 'Verify my code',
    codeNoSend: 'Code not received',
    dontAsk: 'Do not ask me again on this device'
  },
  emailValidation: {
    title: 'Email Verification',
    resend: 'Resend email',
    emailSent: 'An email containing your code has been sent to {userEmail}. Please enter it in the fields below'
  },
  mobilePhoneValidation: {
    title: 'Checking your phone number',
    willSendCode: 'We will send you a validation code by SMS to ensure that the number is yours.',
    numberChanged: 'The phone number used to connect has been changed. Here is the number that has been entered:',
    codeSent: 'An SMS code has been sent to you to validate it. Please enter it below.',
    checkPhoneNumber: 'If this number does not correspond to your current phone number, you can change it.',
    updateMobilePhone: 'Change my phone number',
    invalidPhoneNumber: 'The phone number is invalid'
  },
  lockAccount: {
    lock: 'Lock my account',
    warning: 'You are about to lock your account. Continue?',
    resend: 'Resend email',
    locked: 'The account has been locked. Disconnecting'
  },
  register: {
    title: 'Sign Up',
    subTitle: 'Sign up form',
    subTitlePatient: 'Patient sign up form',
    createNewAccount: 'Create a new account',
    passwordConfirm: 'Confirm password',
    action: 'Sign up',
    registerAs: 'Sign up as',
    error: {
      passwordConfirm: 'Passwords must match',
      emailAlreadyUsed: 'This email address is already in use'
    },
    confirmation: {
      success: {
        title: 'Sign up successful',
        message: 'Your account has been created successfully. You can now log in.',
        redirect: 'You will be redirected to the login form in a few seconds.'
      },
      error: {
        title: 'Sign up failed',
        message: 'An error occurred during sign up. Please try again later.'
      }
    }
  },
  code: {
    sent: 'A new code has been sent',
    incorrect: 'Wrong code',
    expired: 'The code has expired.',
    invalid: 'The code is invalid',
    alreadySent: 'A code has already been sent recently'
  },
  errors: {
    sessionExpired: {
      title: 'Your session has expired'
    },
    expiredLink: 'The connection link has expired.'
  },
  firstLogin: {
    title: 'Set your password',
    welcome: 'Welcome!',
    pendingLogin: 'Connection to your account in progress...',
    resendCode: 'No code received',
    newPassword: 'You can now enter your login password',
    success: {
      success: 'Successful connection!',
      title: 'Password creation successful',
      message: 'The password associated with your account has been successfully created. You can now log in with this password.',
      redirect: 'You will be redirected to the login form in a few seconds.',
      redirectBack: 'You will be redirected to the requested page in a few seconds.'
    },
    error: {
      codeResent: 'Please enter the security code sent by email for log in.'
    }
  },
  biometrics: {
    login: {
      backToNormalLogin: 'Normal login'
    },
    error: {
      biometricsErrorCaptions: 'An error occurred during the identification',
      biometricsKeyInvalidated: 'Your biometric data has expired. A new enrollment will be required'
    },
    enroll: {
      enrollSuccessCaption: 'Biometric login added',
      enrollErrorCaption: 'An issue occurred while registering biometric data',
      warning: 'By enabling biometric login, you accept that all fingerprints stored on this mobile device will allow access to your profile and personal data',
      identificationText: 'Identification by',
      askQuestionPartOne: 'Do you want to use identification by ',
      askQuestionPartTwo: ' for future logins?'
    }
  }
}
